import ClaimDeclarationsService from "@/api/services/claimDeclarations";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  declarationId: null,
  declaration: null,
  contractCategory: null,
  coverages: [],
  products: [],
  planSaleContractType: null,
  productless: null,
  allowAlternativeClaimProduct: null,
  coverage: null,
  occurredAtHome: null,
  fraudulentSimUse: null,
  isInvoiceHolder: null,
};

export default {
  namespaced: true,
  state: initialState,
  mutations: {
    setDeclarationId(state, declarationId) {
      state.declarationId = declarationId;
    },
    resetDeclarationId(state) {
      state.declarationId = null;
    },
    setContractCategory(state, contractCategory) {
      state.contractCategory = contractCategory;
    },
    setCoverages(state, coverages) {
      state.coverages = coverages;
    },
    setProducts(state, products) {
      state.products = products;
    },
    setCoverage(state, coverage) {
      state.coverage = coverage;
    },
    setPlanSaleContractType(state, planSaleContractType) {
      state.planSaleContractType = planSaleContractType;
    },
    setProductless(state, productless) {
      state.productless = productless;
    },
    setAllowAlternativeClaimProduct(state, allowAlternativeClaimProduct) {
      state.allowAlternativeClaimProduct = allowAlternativeClaimProduct;
    },
    setOccurredAtHome(state, occurredAtHome) {
      state.occurredAtHome = occurredAtHome;
    },
    setFraudulentSimUse(state, fraudulentSimUse) {
      state.fraudulentSimUse = fraudulentSimUse;
    },
    setDeclaration(state, declaration) {
      state.declaration = declaration;
    },
    setIsInvoiceHolder(state, isInvoiceHolder) {
      state.isInvoiceHolder = isInvoiceHolder;
    },
  },
  getters: {
    isProductlessPlanSale: (state) => state.productless === true,
    planSaleWithRequiredProduct: (state) => state.productless === false,
    canDeclareAlternativeProduct: (state) => state.allowAlternativeClaimProduct === true,
  },
  actions: {
    async create({ commit }, { planSaleFriendlyId, email }) {
      commit("resetDeclarationId");
      let response = await ClaimDeclarationsService.fetchCreationData({ planSaleFriendlyId, email });
      if (!response?.success) return;

      const data = toCamelCase(response.data);
      const {
        planSaleId,
        contractCategory,
        coverages,
        products,
        planSaleContractType,
        productless,
        allowAlternativeClaimProduct,
      } = data;
      response = await ClaimDeclarationsService.create({ planSaleId });
      if (!response?.success) return;

      commit("setDeclarationId", response.data.id);
      commit("setContractCategory", contractCategory);
      commit("setPlanSaleContractType", planSaleContractType);
      commit("setProductless", productless);
      commit("setAllowAlternativeClaimProduct", allowAlternativeClaimProduct);
      commit("setCoverages", coverages);
      commit("setProducts", products);
    },
    async createNewVersion({ commit }, { claimDeclarationId }) {
      commit("resetDeclarationId");
      let response = await ClaimDeclarationsService.createNewVersion(claimDeclarationId);
      if (!response?.success) return;
      commit("setDeclarationId", response.data.id);
    },
    async fetchDeclaration({ state, commit }) {
      if (!state.declarationId) {
        commit("setDeclaration", null);
        return;
      }
      const response = await ClaimDeclarationsService.show(state.declarationId);
      if (!response?.success) {
        commit("setDeclaration", null);
        return;
      }
      commit("setDeclaration", toCamelCase(response.data));
    },
    async update({ state }, { formData, signal, onUploadProgress }) {
      return await ClaimDeclarationsService.update(state.declarationId, formData, { signal, onUploadProgress });
    },
  },
};
